import React from 'react';
import { BannerWrapper } from './styles/bannerStyles';

const Banner = () => {
    return (
        <BannerWrapper>
            <h3>Developer, Creative Thinker & Problem Solver</h3>
            <p>I combine logic and creativity to bring your idea to life.</p>
        </BannerWrapper>
    )
}

export default Banner
